import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Button, Col, Result, Row } from 'antd';
const CompletedStep = ({ active, onDoAgain }) => {
    const restartImport = (e) => {
        e.preventDefault();
        onDoAgain();
    };
    if (!active) {
        return null;
    }
    return (_jsx(Row, { children: _jsx(Col, { xs: { span: 24, offset: 0 }, md: { span: 12, offset: 6 }, children: _jsx(Result, { status: "success", title: "Import Completed Successfully", subTitle: "The import has completed successfully", extra: [
                    _jsx(Button, { type: "primary", href: "#/app/consignments/list", title: "Go to My Deliveries", children: "Go to My Deliveries" }, "available"),
                    _jsx(Button, { type: "default", href: "#/app/consignments/import", title: "Import another file", onClick: restartImport, children: "Import another file" })
                ] }) }) }));
};
export default CompletedStep;
